import { render, staticRenderFns } from "./ActionResultFullscreen.vue?vue&type=template&id=fbfc0a58"
import script from "./ActionResultFullscreen.vue?vue&type=script&lang=js"
export * from "./ActionResultFullscreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports